export const _setNewFundingType = (state, action) => {
  state.newFundingType = action.payload;
};